<div class="player-container">
  <div class="trainer" *ngIf="trainerUser">
    <div class="credential">
      <h3>{{ "YOUTUBE_VIDEO.TRAINER_TEXT" | translate }}</h3>
      <p>{{trainerUser.displayName}}</p>
    </div>
    <div class="button-container">
      <button mat-raised-button (click)="deleteTrainer()">{{ "YOUTUBE_VIDEO.DISCONNECT_TEXT" | translate }}</button>
    </div>
  </div>
<!--  <carousel-->
<!--    *ngIf="showOptions && showVideo && videoType === 'youtube'"-->
<!--    [cellsToShow]="3"-->
<!--    [cellWidth]="100"-->
<!--    [height]="carouselHeight"-->
<!--    [loop]="true"-->
<!--  style="z-index: 1">-->
<!--    <ng-container *ngFor="let video of videosArray; let i = index">-->
<!--      <div class="carousel-cell" *ngIf="video.imageUrl">-->
<!--        <img [src]="video?.imageUrl" alt="image" (click)="setVideo(video.id, i)"/>-->
<!--              <p>-->
<!--                {{video?.name | slice:0: limitOfCharacters(video.name.length) }}-->
<!--                <span *ngIf="video?.name.length > limitOfCharacters(video.name.length)">...</span>-->
<!--              </p>-->
<!--      </div>-->
<!--    </ng-container>-->
<!--  </carousel>-->
<!--  <div class="portal-button-container" *ngIf="currentUser?.role === 'supervisor' && showOptions">-->
<!--    <button mat-raised-button (click)="openPortal()">{{ "YOUTUBE_VIDEO.OPEN_WINDOW" | translate }}</button>-->
<!--  </div>-->
  <div class="youtube-container" id="youtube" *ngIf="videoType === 'youtube'">
    <button class="volume-menu-trigger" *ngIf="showVideo && !isEmptyVideo()" (click)="toggleVolumeMenu()">
      <mat-icon>settings</mat-icon>
    </button>
    <div class="change-video-container" *ngIf="trainingTime < 60">
      <p (click)="changeVideoDialog()">{{ "YOUTUBE_VIDEO.CHANGE_VIDEO" | translate }}</p>
    </div>
              <youtube-player *ngIf="showVideo"
                              class="youtube-wrap"
                              [videoId]="videoId"
                              [playerVars]="options"
                              (ready)="savePlayer($event)"
              >
              </youtube-player>
    <div class="youtube-cover" *ngIf="youtubeCover"></div>
<!--    <div class="video-options" *ngIf="showVideo && !isEmptyVideo() && currentUser?.role !== 'normal'">-->
<!--      <div class="payback-rate" *ngIf="feedBackType === 'startStop'">-->
<!--        <mat-form-field>-->
<!--          <mat-label>{{ "YOUTUBE_VIDEO.PLAYBACK_RATE" | translate }}</mat-label>-->
<!--          <mat-select [ngModel]="paybackRate" (selectionChange)="setPlayerPlaybackRate($event.value, true)">-->
<!--            <mat-option *ngFor="let rate of paybackRates" [value]="rate">{{rate}}</mat-option>-->
<!--          </mat-select>-->
<!--        </mat-form-field>-->
<!--      </div>-->
<!--      <div class="feedback-type">-->
<!--        <mat-form-field>-->
<!--          <mat-label>{{ "YOUTUBE_VIDEO.FEEDBACK_TYPE" | translate }}</mat-label>-->
<!--          <mat-select [ngModel]="feedBackType" (selectionChange)="changeFeedbackType($event.value)">-->
<!--            <mat-option value="startStop">{{ "YOUTUBE_VIDEO.FEEDBACK_STOP" | translate }}</mat-option>-->
<!--            <mat-option value="slowNormal">{{ "YOUTUBE_VIDEO.FEEDBACK_SLOW" | translate }}</mat-option>-->
<!--          </mat-select>-->
<!--        </mat-form-field>-->
<!--      </div>-->
<!--    </div>-->
  </div>
  <div class="custom-video-container" *ngIf="videoType === 'custom'">
    <button class="volume-menu-trigger" *ngIf="showVideo" (click)="toggleVolumeMenu()">
      <mat-icon>settings</mat-icon>
    </button>
    <div class="change-video-container" *ngIf="trainingTime < 60">
      <p (click)="changeVideoDialog()">{{ "YOUTUBE_VIDEO.CHANGE_VIDEO" | translate }}</p>
    </div>
    <video *ngIf="showVideo" class="player absolute-mid h-100 w-100" id="video-player"  preload="auto"></video>
    <div class="video-options" *ngIf="showVideo && currentUser?.role !== 'normal'">
      <div class="payback-rate">
        <mat-form-field>
          <mat-label>{{ "YOUTUBE_VIDEO.PLAYBACK_RATE" | translate }}</mat-label>
          <mat-select [ngModel]="paybackRate" (selectionChange)="setPlayerPlaybackRate($event.value)">
            <mat-option *ngFor="let rate of paybackRates" [value]="rate">{{rate}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="feedback-type">
        <mat-form-field>
          <mat-label>{{ "YOUTUBE_VIDEO.FEEDBACK_TYPE" | translate }}</mat-label>
          <mat-select [ngModel]="feedBackType" (selectionChange)="changeFeedbackType($event.value)">
            <mat-option value="startStop">{{ "YOUTUBE_VIDEO.FEEDBACK_STOP" | translate }}</mat-option>
            <mat-option value="slowNormal">{{ "YOUTUBE_VIDEO.FEEDBACK_SLOW" | translate }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>

<div class="volume-menu" *ngIf="showVolumeMenu">
  <div class="volume-menu-header">
    <span class="material-symbols-outlined">tune</span>
    <div class="close" (click)="toggleVolumeMenu()">
      <mat-icon>close</mat-icon>
    </div>
  </div>

  <div class="seek-section" *ngIf="videoType === 'youtube' && trainingTemplate && showVideo && !isEmptyVideo() && currentUser?.role !== 'normal'">
    <div class="seek-row">
      <div class="timing">
        <p>{{youtubeVideoTiming(currentYoutubeTime)}}</p>
      </div>
      <mat-slider *ngIf="!isEmptyVideo()" min="0" [max]="maxYoutubeTime" step="1" [value]="currentYoutubeTime" (change)="seekYoutubeVideo($event.value)"></mat-slider>
      <div class="timing">
        <p>{{youtubeVideoTiming(maxYoutubeTime)}}</p>
      </div>
    </div>
    <div class="track-buttons">
      <button [disabled]="videoIndex === 0" (click)="previousYoutubeVideo()">
        <span class="material-symbols-outlined">skip_previous</span>
      </button>
      <button [disabled]="videoIndex > videosArray.length - 2" (click)="nextYoutubeVideo()">
        <span class="material-symbols-outlined">skip_next</span>
      </button>
    </div>
  </div>

  <div class="seek-section" *ngIf="videoType === 'custom' && showVideo && currentUser?.role !== 'normal'">
    <div class="seek-row">
      <div class="timing">
        <p>{{youtubeVideoTiming(currentCustomVideoTime)}}</p>
      </div>
      <mat-slider min="0" [max]="maxCustomVideoTime" step="1" [value]="currentCustomVideoTime" (change)="seekCustomVideo($event.value)"></mat-slider>
      <div class="timing">
        <p>{{youtubeVideoTiming(maxCustomVideoTime)}}</p>
      </div>
    </div>
  </div>

  <div class="volume-section">
    <mat-slider vertical min="0" [max]="100" step="1" [value]="currentVolume" (change)="setVolume($event.value)"></mat-slider>
    <button class="mute-btn" (click)="muteVideo()">
      <img src="{{(videoType === 'youtube' ? videoMuted : muteCustomVideo) ? './assets/images/mute.png' : './assets/images/play.png'}}" alt="mute">
    </button>
  </div>

  <div class="overlay-section" *ngIf="videoType === 'youtube'">
    <mat-checkbox [(ngModel)]="useBlackOverlay">
      {{ "YOUTUBE_VIDEO.USE_BLACK_OVERLAY" | translate }}
    </mat-checkbox>
  </div>
</div>

<div class="video-position-ask" *ngIf="showSeekHint">
  <div class="close" (click)="closeYoutubeHint()">
    <mat-icon>close</mat-icon>
  </div>
  <h3>{{ "VIDEO_HINT.HEADING" | translate }} <b>{{transformSeconds(hintSeconds)}}</b></h3>
  <div class="actions">
    <button class="resume" (click)="setVideoTime()">
      {{ "VIDEO_HINT.CONTINUE" | translate }}
    </button>
    <button class="reset" (click)="clearPlayerTime()">
      {{ "VIDEO_HINT.RESTART" | translate }}
    </button>
  </div>
</div>
